module.exports = __webpack_public_path__ + "static/img/pro1.153c4df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pro1.png
// module id = b/3F
// module chunks = 0